// Copyright (c) 2017 Deere & Company

import SearchFilters from '../../../shared/state/search-filters';

export const getDefaultState = () =>
    new SearchFilters({
        filterBy: '',
        query: '',
        sortBy: ['dueDate'],
        sortDirection: 'ASC'
    });



// WEBPACK FOOTER //
// ./src/tcsm/audits/state/search-filters.js